import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter, NavLink } from "react-router-dom";
import objectAssign from "object-assign";
import { bindActionCreators } from "redux";
import ReactPlaceholder from "react-placeholder";

import { ROUTES } from "../../constants/routeConfig";
import { mapWebsiteLinkPathtoLCLinkPath } from "../../utilities/routeUtilities";

import pageNode from "../../proptypes/brokerGuides/pageNode";
import courseOffering from "../../proptypes/courses/courseOffering";
import courseOfferingMethod from "../../proptypes/courses/courseOfferingMethod";
import * as courseActions from "../../actions/courseActions";
import * as brokerGuidesActions from "../../actions/brokerGuidesActions";

import FeaturedCoursePlaceHolder from "./placeholders/FeaturedCoursePlaceHolder";
import CourseOfferingCard from "../courses/CourseOfferingCard";
import CourseOfferingGroupCard from "../courses/CourseOfferingGroupCard";
import Pagination from '../Pagination';
import {
  sortOnDemandCoursesByDate,
  sortLiveCoursesByDate,
} from "../../utilities/courseUtilities";
import {
  selectCourseOfferings,
  selectRegisteredCoursesForDisplay,
  selectShouldLoadFutureCourses,
} from "../../selectors/courseSelectors";
import { selectIsLoadingRegisteredCourses } from "../../selectors/authSelectors";

import SvgIcon from "./../icon/SvgIcon";
import LandingPageCourseFilters from "./LandingPageCourseFilters";
import ResourcesCard from "../resources/ResourcesCard";
import * as resourceData from "../../resources-page";
import { COURSE_FILTERS } from "../../constants/courseFilters";
import { COURSE_SERIES } from "../../constants/courseSeriesLookup";
import { CONFIGURATION } from "../../constants/config";
import loadingStates from "../../constants/loadingStates";

class LandingPageContent extends React.Component {
  componentWillMount() {
    this.buildFeaturedTutorialsList();

    if (this.props.shouldLoadRegisteredCourses) {
      this.props.actions.getRegisteredCourses();
    }

    var getCourses = this.props.shouldLoadFutureCourses
      ? this.props.actions.getFutureCourses()
      : Promise.resolve(true);

    getCourses.then(() => {
      this.buildFeaturedCourseList();

      this.setState({
        loadingCourses: false,
      });

      this.setCoursesForDisplay(this.state.selectedFilter);

      this.displayRegisteredCourses();
    });
  }

  constructor(props) {
    super(props);

    this.state = {
      loadingCourses: true,
      liveCourses: null,
      onDemandCourses: null,
      coursesForDisplay: [],
      tutorialsForDisplay: [],
      selectedFilter: props.isLoggedIn ? COURSE_FILTERS.REGISTERED_COURSES : COURSE_FILTERS.FEATURED,
      displayRegisteredCourses: props.isLoggedIn,
      currentPage: 1,
      itemsPerPage: 8
    };

    this.buildFeaturedCourseList = this.buildFeaturedCourseList.bind(this);
    this.displayRegisteredCourses = this.displayRegisteredCourses.bind(this);
    this.groupCourses = this.groupCourses.bind(this);
    this.buildFeaturedTutorialsList =
      this.buildFeaturedTutorialsList.bind(this);
    this.setCoursesForDisplay = this.setCoursesForDisplay.bind(this);
    this.setCurrentPage = this.setCurrentPage.bind(this);
  }

  componentDidMount() {
    if (this.props.pageNodes.length === 0 || !this.props.sectionPageNode) {
      this.props.actions.getSection("FilingRequirementsAndProcedures");
    }

  }

  componentDidUpdate(prevProps) {
    if (prevProps.courseOfferings !== this.props.courseOfferings) {
      this.buildFeaturedCourseList();
    }
    if (prevProps.isLoggedIn !== this.props.isLoggedIn
      || prevProps.isLoadingRegisteredCourses !== this.props.isLoadingRegisteredCourses
    ) {
      this.displayRegisteredCourses();
    }
    
    }

    displayRegisteredCourses() {
      if (this.props.isLoggedIn && (this.props.isLoadingRegisteredCourses || this.props.registeredCoursesForDisplay.length > 0)) {
        this.setState({
          displayRegisteredCourses: true,
          selectedFilter: COURSE_FILTERS.REGISTERED_COURSES,
        });
        
        if (!this.props.isLoadingRegisteredCourses) this.setCoursesForDisplay(COURSE_FILTERS.REGISTERED_COURSES);
      } else {
        this.setState({
          displayRegisteredCourses: false,
          selectedFilter: COURSE_FILTERS.FEATURED,
        });
        this.setCoursesForDisplay(COURSE_FILTERS.FEATURED);
      }
    }
  

  groupCourses(liveCourses) {
    let mappedLiveCourses = [];

    liveCourses.forEach((courseOffering) => {
      var matchingCourse = mappedLiveCourses.find(
        (mappedLiveCourse) =>
          mappedLiveCourse.courseId === courseOffering.course.id
      );
      if (matchingCourse) {
        matchingCourse.courseOfferings.push(courseOffering);
        if (courseOffering.featured) {
          matchingCourse.isFeatured = courseOffering.featured;
        }
      } else {
        mappedLiveCourses.push({
          course: courseOffering.course,
          courseId: courseOffering.course.id,
          isFeatured: courseOffering.featured,
          courseOfferings: [courseOffering],
        });
      }
    });

    return mappedLiveCourses;
  }

  buildFeaturedCourseList() {
    let onDemandCourses = this.props.courseOfferings.filter(
      (c) => c.method === courseOfferingMethod.ON_DEMAND
    );
    let liveCourses = this.props.courseOfferings.filter(
      (c) => c.method === courseOfferingMethod.LIVE
    );

    onDemandCourses = sortOnDemandCoursesByDate(onDemandCourses);
    liveCourses = sortLiveCoursesByDate(liveCourses);

    onDemandCourses = this.groupCourses(onDemandCourses);
    liveCourses = this.groupCourses(liveCourses);

    this.setState({
      onDemandCourses: onDemandCourses,
      liveCourses: liveCourses,
    });
  }

  buildFeaturedTutorialsList() {
    // This is where we can hardcode which tutorials we want to feature on the homepage

    let slipTutorials = resourceData.slipTutorials.slice(0, 1);
    let slipProcedures = resourceData.slipProcedures.slice(0, 1);
    let basicFilingTutorials = resourceData.basicFilingTutorials.slice(0, 2);

    let tutorialsForDisplay = [
      ...slipTutorials,
      ...slipProcedures,
      ...basicFilingTutorials,
    ];

    this.setState({
      tutorialsForDisplay: tutorialsForDisplay,
    });
  }

  setCoursesForDisplay(selectedFilter) {
    if (this.state.selectedFilter !== selectedFilter) {
      this.setState({
        currentPage: 1
      })
    }
    this.setState({
      selectedFilter: selectedFilter,

    });

    if (this.state.loadingCourses) {
      return true;
    }

    let complianceConnectionCourses, slaUniversityCourses;
    let filteredOnDemandCourses;
    let featuredCECourses;
    let coursesForDisplay;

    switch (selectedFilter) {
      
      case COURSE_FILTERS.FEATURED:
        // Filter out SL Regulation course
        filteredOnDemandCourses = this.state.onDemandCourses.filter(
          (onDemandCourse) =>
            !onDemandCourse.course.name.includes(
              CONFIGURATION.INTRO_COURSE_NAME
            ) &&
            onDemandCourse.course.seriesId !=
              COURSE_SERIES.COMPLIANCE_CONNECTIONS
            && onDemandCourse.isFeatured == true
        ).sort ((c1, c2) => {
          const publishDate1 = c1.courseOfferings && c1.courseOfferings.length == 0 ? new Date("1/1/1970") : new Date(c1.courseOfferings[0].publishDate);
          const publishDate2 = c2.courseOfferings && c1.courseOfferings.length == 0 ? new Date("1/1/1970") : new Date(c2.courseOfferings[0].publishDate);

          return publishDate2 - publishDate1; //descending
        });

        featuredCECourses = this.state.liveCourses.filter(
          (course) =>
            course.course.seriesId != COURSE_SERIES.COMPLIANCE_CONNECTIONS
            && course.isFeatured == true
        ).sort((c1, c2) => {
          const startDate1 = c1.courseOfferings && c1.courseOfferings.length == 0 ? new Date("1/1/1970") : new Date(c1.courseOfferings[0].date);
          const startDate2 = c2.courseOfferings && c1.courseOfferings.length == 0 ? new Date("1/1/1970") : new Date(c2.courseOfferings[0].date);

          return startDate1 - startDate2; //ascending
        }).concat(filteredOnDemandCourses)
        
        coursesForDisplay = featuredCECourses;
        
        coursesForDisplay.push({
          type: "view-more",
          navigator: {
            route: ROUTES.COURSE_LIST,
            click: () => {
              this.props.actions.resetCourseSearchFilters();
              this.props.actions.changeMethodFilter(
                courseOfferingMethod.ALL
              );
              this.props.actions.changeCECreditsFilter();
            }
          },
          cardCss: "O",
          iconCssClass: "svg-icon blue svg-icon blue all-courses",
          text: "View All \n CE Courses",
          courseId: -1 
        });
        break;
      case COURSE_FILTERS.LIVE:
        coursesForDisplay = [];

        coursesForDisplay.push.apply(
          coursesForDisplay,
          this.state.liveCourses
            .filter(
              (course) =>
                course.course.seriesId != COURSE_SERIES.COMPLIANCE_CONNECTIONS
            )
        );

        coursesForDisplay.sort((c1, c2) => {
          const startDate1 = c1.courseOfferings && c1.courseOfferings.length == 0 ? new Date("1/1/1970") : new Date(c1.courseOfferings[0].date);
          const startDate2 = c2.courseOfferings && c1.courseOfferings.length == 0 ? new Date("1/1/1970") : new Date(c2.courseOfferings[0].date);

          return startDate1 - startDate2; //ascending
        }); 
        coursesForDisplay.push({
          type: "view-more",
          navigator: {
            route: ROUTES.COURSE_LIST,
            click: () => {
              this.props.actions.resetCourseSearchFilters();
              this.props.actions.changeMethodFilter(
                courseOfferingMethod.LIVE
              );
              this.props.actions.changeCECreditsFilter();
            }
          },
          cardCss: "L",
          iconCssClass: "svg-icon red cal",
          text: "View All \n Live CE \n Courses",
          courseId: -1 
        });

        break;
      case COURSE_FILTERS.ON_DEMAND:

        // Filter out SL Regulation course
        filteredOnDemandCourses = this.state.onDemandCourses.filter(
          (onDemandCourse) =>
            !onDemandCourse.course.name.includes(
              CONFIGURATION.INTRO_COURSE_NAME
            ) &&
            onDemandCourse.course.seriesId !=
              COURSE_SERIES.COMPLIANCE_CONNECTIONS
        );

        coursesForDisplay = [];

        coursesForDisplay.push.apply(
          coursesForDisplay,
          filteredOnDemandCourses
        );
        coursesForDisplay.sort((c1, c2) => {
          const publishDate1 = c1.courseOfferings && c1.courseOfferings.length == 0 ? new Date("1/1/1970") : new Date(c1.courseOfferings[0].publishDate);
          const publishDate2 = c2.courseOfferings && c1.courseOfferings.length == 0 ? new Date("1/1/1970") : new Date(c2.courseOfferings[0].publishDate);

          return publishDate2 - publishDate1; //descending
        }); 
        
        coursesForDisplay.push({
          type: "view-more",  
          navigator: {
            route: ROUTES.COURSE_LIST,
            click: () => {
              this.props.actions.resetCourseSearchFilters();
              this.props.actions.changeMethodFilter(
                courseOfferingMethod.ON_DEMAND
              );
              this.props.actions.changeCECreditsFilter();
            }
          },
          cardCss: "O",
          iconCssClass: "svg-icon blue play-screen",
          text: "View All \n On Demand CE \n Courses",
          courseId: -1 
        });
        break;
      case COURSE_FILTERS.TUTORIALS:
        break;

      case COURSE_FILTERS.REGISTERED_COURSES: {
        const liveCourses = this.props.registeredCoursesForDisplay.filter(c => c.courseOfferings && c.courseOfferings[0].method === "L");
        const onDemandCourses = this.props.registeredCoursesForDisplay.filter(c => c.courseOfferings && c.courseOfferings[0].method === "O");
        liveCourses.sort((c1, c2) => {
          const startDate1 = c1.courseOfferings && c1.courseOfferings.length == 0 ? new Date("1/1/1970") : new Date(c1.courseOfferings[0].date);
          const startDate2 = c2.courseOfferings && c1.courseOfferings.length == 0 ? new Date("1/1/1970") : new Date(c2.courseOfferings[0].date);

          return startDate1 - startDate2; //ascending
        }); 
        onDemandCourses.sort((c1, c2) => {
          const publishDate1 = c1.courseOfferings && c1.courseOfferings.length == 0 ? new Date("1/1/1970") : new Date(c1.courseOfferings[0].publishDate);
          const publishDate2 = c2.courseOfferings && c1.courseOfferings.length == 0 ? new Date("1/1/1970") : new Date(c2.courseOfferings[0].publishDate);

          return publishDate2 - publishDate1; //descending
        }); 

        coursesForDisplay = liveCourses.concat(onDemandCourses);
        
        coursesForDisplay.push({
          type: "view-more",
          navigator: {
            route: ROUTES.MY_COURSES_PAGE,
            click: null
          },
          cardCss: "O",
          iconCssClass: "svg-icon blue my-courses",
          text: "View All \n Registered \n Courses",
          courseId: -1 
        });

        if (!coursesForDisplay.length)
          this.setState({ selectedFilter: COURSE_FILTERS.FEATURED });
        break;
      }
      case COURSE_FILTERS.INTRO:
        coursesForDisplay = this.state.onDemandCourses.filter(
          (onDemandCourse) =>
            onDemandCourse.course.name == CONFIGURATION.INTRO_COURSE_NAME
        );
        break;

      case COURSE_FILTERS.COMPLIANCE_CONNECTIONS:
        complianceConnectionCourses = this.state.liveCourses
          .filter(
            (course) =>
              course.course.seriesId == COURSE_SERIES.COMPLIANCE_CONNECTIONS
          ).sort((c1, c2) => {
            const startDate1 = c1.courseOfferings && c1.courseOfferings.length == 0 ? new Date("1/1/1970") : new Date(c1.courseOfferings[0].date);
            const startDate2 = c2.courseOfferings && c1.courseOfferings.length == 0 ? new Date("1/1/1970") : new Date(c2.courseOfferings[0].date);

            return startDate1 - startDate2; //ascending
          })
          .concat(
            this.state.onDemandCourses.filter(
              (course) =>
                course.course.seriesId == COURSE_SERIES.COMPLIANCE_CONNECTIONS
            ).sort((c1, c2) => {
              const publishDate1 = c1.courseOfferings && c1.courseOfferings.length == 0 ? new Date("1/1/1970") : new Date(c1.courseOfferings[0].publishDate);
              const publishDate2 = c2.courseOfferings && c1.courseOfferings.length == 0 ? new Date("1/1/1970") : new Date(c2.courseOfferings[0].publishDate);

              return publishDate2 - publishDate1; //descending
            })
          );
        coursesForDisplay = complianceConnectionCourses;
        
        coursesForDisplay.push({
          type: "view-more",
          navigator: {
            route: ROUTES.COURSE_LIST,
            click: () => {
              this.props.actions.resetCourseSearchFilters();
              this.props.actions.toggleComplianceConnections();
            }
          },
          cardCss: "O",
          iconCssClass: "svg-icon blue compliance-connections",
          text: "View All \n Compliance Connection \n Courses",
          courseId: -1 
        });
        break;

      case COURSE_FILTERS.SLA_UNIVERSITY:
        slaUniversityCourses = this.state.liveCourses
          .filter(
            (course) => course.course.seriesId == COURSE_SERIES.SLA_UNIVERSITY
          ).sort((c1, c2) => {
            const startDate1 = c1.courseOfferings && c1.courseOfferings.length == 0 ? new Date("1/1/1970") : new Date(c1.courseOfferings[0].date);
            const startDate2 = c2.courseOfferings && c1.courseOfferings.length == 0 ? new Date("1/1/1970") : new Date(c2.courseOfferings[0].date);

            return startDate1 - startDate2; //ascending
          })
          .concat(
            this.state.onDemandCourses.filter(
              (course) => course.course.seriesId == COURSE_SERIES.SLA_UNIVERSITY
            ).sort ((c1, c2) => {
              const publishDate1 = c1.courseOfferings && c1.courseOfferings.length == 0 ? new Date("1/1/1970") : new Date(c1.courseOfferings[0].publishDate);
              const publishDate2 = c2.courseOfferings && c1.courseOfferings.length == 0 ? new Date("1/1/1970") : new Date(c2.courseOfferings[0].publishDate);

              return publishDate2 - publishDate1; //descending
            })
          );
        coursesForDisplay = slaUniversityCourses;
        coursesForDisplay.push({
          type: "view-more",
          navigator: {
            route: ROUTES.COURSE_LIST,
            click: () => {
              this.props.actions.resetCourseSearchFilters();
              this.props.actions.toggleSlaUniversity();
            }
          },
          cardCss: "O",
          iconCssClass: "svg-icon blue university",
          text: "View all \n SLA University \n courses",
          courseId: -1 
        });
        break;
    }

    this.setState({
      coursesForDisplay: coursesForDisplay,
      showCoursesForDisplay: this.state.coursesForDisplay
    });

  }

  setCurrentPage = (pageNumber) => {
    this.setState({
      currentPage: pageNumber,
    });
  };

  render() {
    let renderTutorialCards =
      this.state.selectedFilter == COURSE_FILTERS.TUTORIALS;
    let renderCourseCards = !renderTutorialCards;
    let loadingRegisteredCourses = (this.state.selectedFilter === COURSE_FILTERS.REGISTERED_COURSES && this.props.isLoadingRegisteredCourses);

    return (
      <div className="landing-page-content-container">
        <LandingPageCourseFilters
          setCoursesForDisplay={this.setCoursesForDisplay}
          selectedFilter={this.state.selectedFilter}
          displayRegisteredCourses={this.state.displayRegisteredCourses}
        />

        <div className="landing-page-course-cards">
          {this.state.selectedFilter == COURSE_FILTERS.COMPLIANCE_CONNECTIONS &&
            this.state.coursesForDisplay.length == 0 &&
            !this.state.loadingCourses && (
              <div className="text-center">
                Compliance Connection courses are coming soon.
              </div>
            )}

          {this.state.selectedFilter == COURSE_FILTERS.SLA_UNIVERSITY &&
            this.state.coursesForDisplay.length == 0 &&
            !this.state.loadingCourses && (
              <div className="text-center">
                SLA University courses are coming soon.
              </div>
            )}

          {this.state.selectedFilter == COURSE_FILTERS.LIVE &&
            this.state.coursesForDisplay.length == 0 &&
            !this.state.loadingCourses && (
              <div className="text-center">
                More Live Courses are on the way. Check back soon.
              </div>
            )}

          {!renderTutorialCards && (
            <ReactPlaceholder
              showLoadingAnimation
              ready={!this.state.loadingCourses && !loadingRegisteredCourses}
              customPlaceholder={FeaturedCoursePlaceHolder}
            >
              <div className="row">
                {renderCourseCards &&
                  this.state.coursesForDisplay.slice(((this.state.currentPage * this.state.itemsPerPage) - this.state.itemsPerPage), (this.state.currentPage * this.state.itemsPerPage)).map((courseListItem) => (
                    <div
                      key={courseListItem.courseId}
                      className={
                        "col-6 col-xl-3 col-md-6 col-12 col-sm-11 col-xs-3"
                      }
                    >
                      {
                        courseListItem.type === "view-more" ? 
                        (
                          <div className={`course-card ${courseListItem.cardCss} view-more-courses`}>
                            
                            <NavLink
                                to={courseListItem.navigator.route}
                                onClick={courseListItem.navigator.click}
                              >
                                  <span className={`${courseListItem.iconCssClass}`} />
                                  <br/><br/>
                                  <span className="view-more-text">
                                    {courseListItem.text}
                                  </span>
                            </NavLink>
                          </div>
                        )
                      : courseListItem.courseOfferings.length > 1 ? (
                        <CourseOfferingGroupCard
                          key={courseListItem.courseId}
                          courseOfferingGroup={courseListItem}
                        />
                      ) : (
                        <CourseOfferingCard
                          key={courseListItem.courseOfferings[0].id}
                          featured
                          courseOffering={courseListItem.courseOfferings[0]}
                        />
                      )}
                    </div>
                  ))}
              </div>
            </ReactPlaceholder>
          )}

          {renderTutorialCards && (
            <div className="row">
              {this.state.tutorialsForDisplay.map((tutorial) => {
                return (
                  <div key={tutorial.key} className={"col-xs-12 col-sm-6"}>
                    <ResourcesCard
                      tutorial={tutorial.value}
                      key={tutorial.key}
                    />
                  </div>
                );
              })}
            </div>
          )}
        </div>
   <div className='row'></div>
        <div className="div-Pagination"><Pagination
          filteredCoursesPage={this.state.coursesForDisplay}
          itemsPerPage={this.state.itemsPerPage}
          currentPage={Number(this.state.currentPage)}
          setCurrentPage={this.setCurrentPage}
        ></Pagination></div>
        <div className="landing-page-resources-panel-container">
          <div className="landing-page-resources-panel">
            <div className="resources-panel-header">
              <div className="header">
                <SvgIcon icon="resources" color="white" />
                <h1 className="left-block white large d-inline-block">
                  Resources
                </h1>
              </div>
              <div className="sub-header">
                View filing tutorials, bulletins, and other helpful information.
              </div>
            </div>

            <div className="resources-panel-links">
              <div className="row">
                <div className="col-xs-12 col-sm-6">
                  <NavLink to={ROUTES.NOTICES_PAGE}>
                    <div className="svg-icon-container">
                      <SvgIcon icon="info" color="white" />
                    </div>
                    <div className="btn-text notices">Notices</div>
                    <SvgIcon icon="chevron-right" color="white" />
                  </NavLink>
                </div>

                <div className="col-xs-12 col-sm-6">
                  <NavLink to={ROUTES.BULLETINS_PAGE}>
                    <div className="svg-icon-container">
                      <SvgIcon icon="pin" color="white" />
                    </div>
                    <div className="btn-text">Bulletins</div>
                    <SvgIcon icon="chevron-right" color="white" />
                  </NavLink>
                </div>

                <div className="col-xs-12 col-sm-6">
                  <NavLink to={ROUTES.TUTORIALS_PAGE}>
                    <div className="svg-icon-container">
                      <SvgIcon icon="video-call" color="white" />
                    </div>
                    <div className="btn-text tutorials">Tutorials</div>
                    <SvgIcon icon="chevron-right" color="white" />
                  </NavLink>
                </div>

                <div className="col-xs-12 col-sm-6">
                  <NavLink to={ROUTES.FAQS_PAGE}>
                    <div className="svg-icon-container">
                      <SvgIcon icon="faqs" color="white" />
                    </div>
                    <div className="btn-text">FAQS</div>
                    <SvgIcon icon="chevron-right" color="white" />
                  </NavLink>
                </div>

                <div className="col-12">
                  {this.props.pageNodes.length > 0 &&
                    this.props.sectionPageNode && (
                      <NavLink
                        to={mapWebsiteLinkPathtoLCLinkPath(
                          this.props.pageNodes[0].relativeUrlPath
                        )}
                      >
                        <div className="svg-icon-container">
                          <SvgIcon icon="file-requirements" color="white" />
                        </div>
                        <div className="btn-text">
                          {this.props.sectionPageNode.title}
                        </div>
                        <SvgIcon icon="chevron-right" color="white" />
                      </NavLink>
                    )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

LandingPageContent.propTypes = {
  actions: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  courseOfferings: PropTypes.arrayOf(PropTypes.shape(courseOffering)),
  isLoggedIn: PropTypes.bool.isRequired,
  registeredCoursesForDisplay: PropTypes.arrayOf(PropTypes.object).isRequired,
  isLoadingRegisteredCourses: PropTypes.bool.isRequired,
  shouldLoadFutureCourses: PropTypes.bool.isRequired,
  shouldLoadRegisteredCourses: PropTypes.bool.isRequired,
  currentUser: PropTypes.object.isRequired,
  pageNodes: PropTypes.arrayOf(PropTypes.shape(pageNode)),
  sectionPageNode: PropTypes.shape(pageNode),
  currentPage: PropTypes.number
};

function mapStateToProps(state) {
  return {
    courseOfferings: selectCourseOfferings(state),
    registeredCoursesForDisplay: selectRegisteredCoursesForDisplay(state),
    shouldLoadFutureCourses: selectShouldLoadFutureCourses(state),
    shouldLoadRegisteredCourses:
      state.auth.isLoggedIn &&
      selectIsLoadingRegisteredCourses(state) === loadingStates.NOT_LOADED,
    isLoadingRegisteredCourses: selectIsLoadingRegisteredCourses(state) === loadingStates.LOADING,
    isLoggedIn: state.auth.isLoggedIn,
    currentUser: state.auth.currentUser,
    pageNodes: state.brokerGuides.pageNodes,
    sectionPageNode: state.brokerGuides.sectionPageNode,
  };
}

function mapDispatchToProps(dispatch) {
  const combinedActions = objectAssign({}, courseActions, brokerGuidesActions);

  return {
    actions: bindActionCreators(combinedActions, dispatch),
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(LandingPageContent)
);